

export default {
    namespaced:true,
    state: {
      /**是否为后台系统 */
      isMag:true,
    },
    mutations: {
      /**切换系统 */
      changeMag(state,data){
        state.isMag=data;
      },
    },
    actions: {
       
    }
};